export default {
  // 电子合同常见问题解答
  faqData: [
    {
      key: 1,
      title: '电子合同具备法律效力吗？法院认可吗？',
      desc: [
        '根据《中华人民共和国电子签名法》第十四条规定：可靠电子签名与传统签字盖章具有同等的法律效力。',
        '使用可靠的电子签名签署的电子合同，得到各层级、各地区法院的广泛认可，形成的判决文书实例已不下数万份。',
      ],
      imgSrc: require('@/assets/images/sem-qa/faq0.png'),
    },
    {
      key: 2,
      title: '电子合同支持哪些场景？',
      desc: ['电子合同适用各行业签署场景，包含采购、物流、销售、分销、招投标、租赁、人事、劳务用工、教育培训、金融等。'],
      imgSrc: require('@/assets/images/sem-qa/faq1.png'),
    },
    {
      key: 3,
      title: '电子合同怎么用？',
      desc: [
        '新用户完成实名认证；导入合同文件；填入签署参与公司/人；发起合同，对方短信或者微信等接收签署链接，进行实名/意愿认证后即完成合同签署。',
      ],
      imgSrc: require('@/assets/images/sem-qa/faq2.png'),
    },
    {
      key: 4,
      title: '电子合同、电子印章怎么收费？',
      desc: [
        '电子印章是电子合同的重要组成部分，用户在e签宝完成实名认证，即可获得由CA机构颁发的可信数字证书，生成法律认可的电子印章。',
        '在e签宝平台签署使用时按合同份数收费，即签署一份合同收取一次份数费用，付费方为发起方，比如A企业发给B企业签署一份合作协议，A企业为付费方，B企业无需付费。',
      ],
      imgSrc: require('@/assets/images/sem-qa/faq3.png'),
    },
    {
      key: 5,
      title: '怎么部署？可以对接自己的业务系统吗？',
      desc: [
        'e签宝为客户提供多种产品服务：',
        '1、公有云SaaS-即买即用（适合大部分中小微企业）按照合同份数收费；',
        '2、API对接-接口调用开发使用（适合自有系统或平台的企业）按技术服务费+合同份数收费；',
        '3、混合云本地化部署，费用按需定制。',
      ],
      imgSrc: require('@/assets/images/sem-qa/faq4.png'),
    },
  ],

  productPower: {
    title: '灵活产品与能力',
    powerList: [
      {
        name: '公有云SaaS平台',
        iconUrl: require(`../../assets/images/power1.png`),
        toWho: '适用对象：成长型中小企业',
        descList: [
          '超高性价比选择',
          '开通即用，功能丰富，签管一体',
          '智能AI与电子合同的完美结合',
          '一处发起，多处签署',
          '覆盖PC、微信、支付宝、APP等六大端',
        ],
        link: '免费试用',
        url: 'https://www.baidu.com',
      },
      {
        name: '公有云API开放平台',
        iconUrl: require(`../../assets/images/power2.png`),
        toWho: '适用对象：中大型企业组织',
        descList: [
          '快速集成OA/CRM/SCM/EHR/ERP 等原有业务系统',
          '参数自定义，性能强，商业模式灵活',
          '多种签署体验，覆盖全部行业场景应用',
          '多种对接方案，满足深度融合需求',
          '全程取证、司法机构广泛认可',
        ],
        link: '立即接入',
        url: 'https://www.baidu.com',
      },
      {
        name: '混合云印章平台',
        iconUrl: require(`../../assets/images/power3.png`),
        toWho: '适用对象：集团型企业',
        descList: [
          '科学中立的相对方模型',
          '原文沙箱专利技术，确保隐私安全',
          '私有化部署，核心数据不出网',
          '支持“国产化信创&国际通用” 双重环境规范',
          '物电一体，整合印控仪、电子印章一体化方案',
          '1000+大型组织信息化建设应用沉淀',
        ],
        link: '立即接入',
        url: 'https://www.baidu.com',
      },
      {
        name: '钉钉签名',
        iconUrl: require(`../../assets/images/power4.png`),
        toWho: '适用对象：钉钉平台企业用户',
        descList: ['钉钉原生电子签名官方应用', '与钉钉多项原生功能深度融合', '支持内/外部签署场景', '已服务钉钉平台百万级客户'],
        link: '免费试用',
        url: 'https://www.baidu.com',
      },
    ],
  },
  // 无需邮寄，1分钟完成线上签署
  flowPathOneLine: [
    {
      key: 1,
      imgSrc: require('@/assets/images/sem-saas/flow-one.png'),
      text: '实名认证',
    },
    {
      key: 2,
      imgSrc: require('@/assets/images/sem-saas/flow-two.png'),
      text: '申领印章',
    },
    {
      key: 3,
      imgSrc: require('@/assets/images/sem-saas/flow-three.png'),
      text: '线上签署',
    },
    {
      key: 4,
      imgSrc: require('@/assets/images/sem-saas/flow-four.png'),
      text: '发送合同',
    },
  ],
  flowPathTwoLine: [
    {
      key: 1,
      imgSrc: require('@/assets/images/sem-saas/flow-five.png'),
      text: '司法服务',
    },
    {
      key: 2,
      imgSrc: require('@/assets/images/sem-saas/flow-six.png'),
      text: '全流程上链',
    },
    {
      key: 3,
      imgSrc: require('@/assets/images/sem-saas/flow-seven.png'),
      text: '合同管理',
    },
    {
      key: 4,
      imgSrc: require('@/assets/images/sem-saas/flow-eight.png'),
      text: '对方签署',
    },
  ],

  // 行业实践解决方案
  solutions: {
    title: '行业实践解决方案',
    list: [
      {
        videoUrl: require('../../assets/video/human-resource.mp4'),
        imgUrl: require('../../assets/images/solution1.png'),
        link: '免费试用>',
        text: '人力资源',
        url: 'https://www.baidu.com',
        maskShow: true,
        videoShow: false,
      },
      {
        videoUrl: require('../../assets/video/logistics.mp4'),
        imgUrl: require('../../assets/images/solution2.png'),
        link: '免费试用>',
        text: '物流',
        url: 'https://www.baidu.com',
        maskShow: true,
        videoShow: false,
      },
      {
        videoUrl: require('../../assets/video/bank.mp4'),
        imgUrl: require('../../assets/images/solution3.png'),
        link: '免费试用>',
        text: '银行',
        url: 'https://www.baidu.com',
        maskShow: true,
        videoShow: false,
      },
      {
        videoUrl: require('../../assets/video/car-leasing.mp4'),
        imgUrl: require('../../assets/images/solution4.png'),
        link: '免费试用>',
        text: '汽车',
        url: 'https://www.baidu.com',
        maskShow: true,
        videoShow: false,
      },
      {
        videoUrl: require('../../assets/video/medical.mp4'),

        // imgUrl: require('../../assets/images/solution5.png'),
        imgUrl: require('../../assets/images/solution8.png'),
        link: '免费试用>',
        text: '医疗',
        url: 'https://www.baidu.com',
        maskShow: true,
        videoShow: false,
      },
      {
        videoUrl: require('../../assets/video/construction.mp4'),

        // imgUrl: require('../../assets/images/solution6.png'),
        imgUrl: require('../../assets/images/solution7.png'),
        link: '免费试用>',
        text: '房地产',
        url: 'https://www.baidu.com',
        maskShow: true,
        videoShow: false,
      },
      {
        videoUrl: require('../../assets/video/e-commerce.mp4'),

        // imgUrl: require('../../assets/images/solution7.png'),
        imgUrl: require('../../assets/images/solution6.png'),
        link: '免费试用>',
        text: 'B2B电商',
        url: 'https://www.baidu.com',
        maskShow: true,
        videoShow: false,
      },
      {
        videoUrl: require('../../assets/video/online-education.mp4'),

        // imgUrl: require('../../assets/images/solution8.png'),
        imgUrl: require('../../assets/images/solution5.png'),
        link: '免费试用>',
        text: '在线教育',
        url: 'https://www.baidu.com',
        maskShow: true,
        videoShow: false,
      },
    ],
  },

  // e签宝核心优势
  superiority: {
    title: 'e签宝核心优势',
    numberList: [
      {
        num: '156',
        numText: '著作权',
      },
      {
        num: '20',
        numText: '发明专利',
      },
      {
        num: '2',
        numText: '国家课题',
      },
    ],
    textList: [
      {
        iconUrl: require('../../assets/images/superiority1.png'),
        contitle: '超强服务性能',
        descList: ['超级计算集群：云服务器数量近万台', '日均签署量：2000万次', '平均签署耗时：199ms', '数据可靠性：99.99999%'],
      },
      {
        iconUrl: require('../../assets/images/superiority2.png'),
        contitle: '核心专利技术',
        descList: [
          '原文沙箱保护技术',
          '多时间戳证据固化技术',
          '区块链保全技术',
          '盲数字水印技术',
          '国产算法和版式文件支持',
          '基于分布式密钥的文件安全技术',
        ],
      },
      {
        iconUrl: require('../../assets/images/superiority3.png'),
        contitle: 'AI智能合同',
        descList: [
          '提供智能合同模板，智能层级审批',
          '智能比对，精准率接近100%',
          '合同自动分类，支持批量签署',
          '实时追踪合同进度，智能提醒',
          '智能台账，数据抓取分析',
          '智能印章管理',
        ],
      },
      {
        iconUrl: require('../../assets/images/superiority4.png'),
        contitle: '大型客户应用实践',
        descList: [
          '浙江省"最多跑一次"指定电子签供应商',
          '100+世界五百强客户',
          '200+中国五百强客户',
          '150+ 全国省/市政府客户',
          '1500+政务服务应用',
        ],
      },
      {
        iconUrl: require('../../assets/images/superiority5.png'),
        contitle: '完整生态网络',
        descList: [
          '3000+生态伙伴深度融合',
          'OA：钉钉、蓝凌、致远等',
          'CRM：salesforce 、纷享销客、销帮帮等',
          'EHR：Moka招聘、北森、薪福通、肯耐珂萨等',
          'ERP：SAP、用友、明源等',
        ],
      },
      {
        iconUrl: require('../../assets/images/superiority6.png'),
        contitle: '参与行业标准制定',
        descList: [
          '国家密标委标准化委员会首批成员单位',
          '参与多项国家和地方行业标准制定',
          '《基于云的电子签名服务技术要求》',
          '《电子合同订立流程规范》',
          '《浙江省电子印章标准》',
          '《电子招投标密码应用技术规范》',
        ],
      },
      {
        iconUrl: require('../../assets/images/superiority7.png'),
        contitle: '权威资质认可',
        descList: [
          '商用密码产品认证证书',
          '涉密信息系统产品检测证书',
          '信息系统安全专用产品销售许可证',
          'ISO27001认证',
          'ISO27018认证',
          'ISO27701认证',
        ],
      },
      {
        iconUrl: require('../../assets/images/superiority8.png'),
        contitle: '齐全的法律服务',
        descList: [
          '出具多种类型证据报告',
          '包括司法鉴定意见书、公证书',
          'e签宝全过程证明',
          '提供法律咨询、质证服务',
          '电子证据法律咨询服务',
          '互联网业务流程公证服务',
        ],
      },
    ],
  },

  // 客户成功案例
  orgList: {
    title: '客户成功案例',
    orgTypeList: ['人力资源', '地产租房', '互联网+', '银行金融', '零售制造', '汽车物流', '教育旅游', '公共服务'],
    imgs: ['humanRes', 'logistics', 'hlw', 'bank', 'lszz', 'qqwl', 'jjly', 'ggfw'].map((item) => {
      return require(`@/assets/images/${item}.png`)
    }),
  },

  // 签合同·用e签宝
  numberInfo: {
    title: '签合同·用e签宝',
    btnText: '免费试用',
    numberList: ['63.27', '316.34', '5.27'],
    qrImgUrl: require(`../../assets/images/qr-code.png`),
  },
}
